import {Component, Input, OnInit} from '@angular/core';
import {TypeAvisEnum,TooltipIconTextEnum} from "../constant/enum";
import {
  getIconMarin,
  getValidationStatus
} from '../util/camp-utils'
import {Observable} from "rxjs";
import {ICamp} from "../model/camp.model";
import {IProjetAnnee} from "../model/projet-annee.model";
import {getProjetAnneeValidationStatus} from "../util/projet-annee-utils";
@Component({
    selector: 'ddc-tooltip-icon',
    templateUrl: './tooltip-icon.component.html',
    styleUrls: ['./tooltip-icon.component.scss'],
    standalone: false
})
export class TooltipIconComponent implements OnInit {

  camp$: Observable<ICamp>;

  @Input() set icon(icon: string) {
    this._icon = icon;
  }

  @Input() set camp(camp: ICamp) {
    this._camp = camp;
  }

  @Input() set projetAnnee(projetAnnee: IProjetAnnee) {
    this._projetAnnee = projetAnnee;
  }

  @Input() set iconText(iconText: string) {
    this._iconText = iconText;
  }

  @Input() set imgSource(imgSource: string) {
    this._imgSource = imgSource;
  }

  @Input() set iconDisabled(iconDisabled: boolean) {
    this._iconDisabled = iconDisabled;
  }

  _icon?: string;
  _iconText: string;
  _imgSource?: string;
  _iconDisabled?: boolean;

  getIconMarin = getIconMarin;
  getValidationStatus = getValidationStatus;
  getProjetAnneeValidationStatus = getProjetAnneeValidationStatus;

  TypeAvisEnum? = TypeAvisEnum;
  TooltipIconTextEnum = TooltipIconTextEnum;
  _camp? : ICamp;
  _projetAnnee? : IProjetAnnee;

  switchIcon: boolean;

  constructor() { }

  ngOnInit() {
    if(!this._icon
      && this._iconText
      && this._imgSource
      && (this._imgSource === TypeAvisEnum.INTERNATIONAL
      || this._imgSource === TypeAvisEnum.MARIN)){

      this.switchIcon = true;
    }
  }
}
